import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-loc.svg'
import _imports_1 from '@/assets/icon-zoom-in.svg'
import _imports_2 from '@/assets/icon-zoom-out.svg'


const _withScopeId = n => (_pushScopeId("data-v-8ca4bce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_0,
  alt: "location"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "jr-shadow jr-rounded-lg jr-bg-white" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_1,
  alt: "zoom in"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "jr-w-3/4 jr-m-auto jr-border-gray-light" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-m-auto",
  src: _imports_2,
  alt: "zoom out"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "right_column jr-w-full jr-pt-5 jr-pl-5 jr-pr-5" }
const _hoisted_11 = { class: "jr-bg-white jr-w-full jr-px-5 jr-pb-7 jr-pt-3 jr-rounded" }
const _hoisted_12 = { class: "jr-flex jr-justify-between jr-pb-1.25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark" }, "曜日別", -1))
const _hoisted_14 = { class: "jr-border-t-1 jr-border-dashed jr-border-blue-light-soft jr-mt-4.5" }
const _hoisted_15 = { class: "jr-border-t-1 jr-border-dashed jr-border-blue-light-soft jr-mt-4.5 jr-pt-5.5" }
const _hoisted_16 = { class: "jr-pt-7.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomControl = _resolveComponent("CustomControl")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_UIRoadToggle = _resolveComponent("UIRoadToggle")!
  const _component_UITimeSeriesController = _resolveComponent("UITimeSeriesController")!
  const _component_UIColorToggler = _resolveComponent("UIColorToggler")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_UICheckboxFilter = _resolveComponent("UICheckboxFilter")!
  const _component_UITimeSlider = _resolveComponent("UITimeSlider")!
  const _component_UICheckbox = _resolveComponent("UICheckbox")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_FilterWrapper = _resolveComponent("FilterWrapper")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentWrapper, {
      title: _ctx.loadTitles,
      subtitle: _ctx.subtitle,
      filters: [],
      dayLabel: _ctx.getDayLabel,
      timeLabel: _ctx.timeRangeLabel,
      startDate: _ctx.startDate,
      endDate: _ctx.endDate,
      onResetWeek: _ctx.onResetWeek,
      onResetTime: _ctx.onResetTime,
      onDownload: _ctx.handleDownload,
      "show-download": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_GoogleMap, {
            id: "google-map",
            ref: "gMap",
            language: "ja",
            region: "JP",
            libraries: ['visualization', 'places', 'drawing'],
            "api-key": _ctx.apiKey,
            center: _ctx.center,
            disableDefaultUi: true,
            draggable: true,
            clickableIcons: false,
            styles: _ctx.mapStyle,
            tilt: 0,
            heading: 0,
            zoom: _ctx.defaultZoom,
            maxZoom: _ctx.maxZoom,
            onIdle: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomControl, { position: "RIGHT_BOTTOM" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["jr-mr-15", { small: _ctx.minimum, large: !_ctx.minimum }])
                  }, [
                    _createElementVNode("button", {
                      class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-lg jr-mb-2.5",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCurrentLocation && _ctx.handleCurrentLocation(...args)))
                    }, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-t-lg",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleZoomIn && _ctx.handleZoomIn(...args)))
                      }, _hoisted_6),
                      _hoisted_7,
                      _createElementVNode("button", {
                        class: "jr-block jr-w-7.5 jr-h-7.5 jr-bg-white jr-rounded-b-lg",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleZoomOut && _ctx.handleZoomOut(...args)))
                      }, _hoisted_9)
                    ])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["api-key", "center", "styles", "zoom", "maxZoom", "onIdle"]),
          _createVNode(_component_UIRoadToggle, {
            class: "jr-absolute jr-top-30 jr-right-2.5",
            "data-html2canvas-ignore": "true",
            style: _normalizeStyle({ marginRight: _ctx.minimum ? '74px' : '310px' }),
            onToggle: _ctx.handleShowRoadChange
          }, null, 8, ["style", "onToggle"]),
          (_ctx.isPrepareHeatmap)
            ? (_openBlock(), _createBlock(_component_UITimeSeriesController, {
                key: 0,
                class: "time_slider jr-absolute jr-bottom-5 jr-ml-5 jr-w-10/12",
                from: 0,
                to: 24,
                center: 0,
                gap: 1,
                frame: 0.1,
                "fix-num": 2,
                step: 2*_ctx.tableUnitVal,
                onChange: _ctx.onTimeSeriesChange
              }, null, 8, ["frame", "step", "onChange"]))
            : _createCommentVNode("", true),
          _createVNode(_component_UIColorToggler, {
            class: "transition-indicator jr-absolute jr-bottom-18",
            "capture-clip": _ctx.isCapturing,
            style: _normalizeStyle({ left: _ctx.isCapturing ? '10px' : _ctx.sbMinimum ? '74px' : '250px' }),
            colors: _ctx.colors
          }, null, 8, ["capture-clip", "style", "colors"])
        ])
      ]),
      _: 1
    }, 8, ["title", "subtitle", "dayLabel", "timeLabel", "startDate", "endDate", "onResetWeek", "onResetTime", "onDownload"]),
    _createVNode(_component_FilterWrapper, {
      onMinimum: _ctx.minimumHandler,
      class: _normalizeClass({ 'jr-pl-5 jr-pr-5': _ctx.isCapturing })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["jr-w-full jr-flex jr-justify-end", { 'jr-pt-18': _ctx.isCapturing }])
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("button", {
                  class: "jr-text-xxs-1 jr-text-blue-bold",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleResetDayFilter && _ctx.handleResetDayFilter(...args)))
                }, "クリア")
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_UICheckboxFilter, {
                  modelValues: _ctx.dayFilter,
                  "onUpdate:modelValues": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dayFilter) = $event)),
                  options: _ctx.availableDayFilter,
                  type: "day"
                }, null, 8, ["modelValues", "options"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_UITimeSlider, {
                  time: _ctx.$store.state.hourSeries.time,
                  "onUpdate:time": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.$store.state.hourSeries.time) = $event)),
                  isHideUnspecifiedValue: true,
                  min: 0,
                  max: 24
                }, null, 8, ["time"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_UICheckbox, {
                  label: "対象道路近辺のログを非表示にする",
                  modelValue: _ctx.except,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.except) = $event)),
                  labelClasses: "jr-text-primary jr-text-s jr-font-bold jr-tracking-wide",
                  align: "top"
                }, null, 8, ["modelValue"])
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_UIButton, {
              class: "jr-w-full jr-text-center jr-h-10 jr-leading-10 jr-text-sm jr-rounded",
              label: '適用',
              type: 'primary',
              onClick: _ctx.filterContent
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onMinimum", "class"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}